"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.priceForQuantity = exports.pricePerPoundForQuantity = exports.getPackagingType = exports.getShortUnitName = exports.isSkuIndividuallyWrapped = exports.getUnitName = exports.discountDecimal = void 0;
var math_1 = require("../utils/math");
var money_1 = require("../utils/money");
var singularize_1 = __importDefault(require("../utils/singularize"));
var discountDecimal = function (_a, quantity) {
    var weight = _a.weight, wholesale = _a.wholesale;
    if (wholesale === true) {
        return 0;
    }
    if (weight === 1) {
        if (quantity <= 5) {
            return 0.0;
        }
        return quantity <= 10 ? 0.03 : 0.05;
    }
    if (quantity <= 1) {
        return 0.03;
    }
    return quantity <= 2 ? 0.05 : 0.1;
};
exports.discountDecimal = discountDecimal;
var getUnitName = function (variantName) {
    if (!variantName) {
        return undefined;
    }
    var lowercaseName = variantName.toLowerCase();
    var replacementCount = 0;
    // first try "cases of 24 cans" => "case of 24 cans"
    var packagingTest = /^(jars|boxes|cases|containers|packs|packages|tins)(?= of )/;
    lowercaseName = lowercaseName.replace(packagingTest, function (match) {
        replacementCount += 1;
        return (0, singularize_1.default)(match);
    });
    if (replacementCount) {
        return lowercaseName;
    }
    // if it looks like "12 x 3 ounce bags", it works as singular or plural so leave it
    if (/^\d+ *x /.test(lowercaseName)) {
        return lowercaseName;
    }
    // if that didn't find anything, then try to singularize a trailing noun
    packagingTest =
        /(?:^| )(bags|blocks|boxes|cases|containers|jars|mixes|packages|packs|pies|samples|tins|trays|bars)$/;
    lowercaseName = lowercaseName.replace(packagingTest, function (match) {
        return (0, singularize_1.default)(match);
    });
    return lowercaseName;
};
exports.getUnitName = getUnitName;
var isSkuIndividuallyWrapped = function (isBulk, isWholesale, variantName) {
    return !(isBulk && isWholesale) ||
        (variantName === null || variantName === void 0 ? void 0 : variantName.toLowerCase().includes('individually wrapped')) ||
        false;
};
exports.isSkuIndividuallyWrapped = isSkuIndividuallyWrapped;
var getShortUnitName = function (variantName) {
    if (!variantName) {
        return undefined;
    }
    var trimmed = variantName.replace(/ ?\([^(]+\)$/, '');
    var name = (0, exports.getUnitName)(trimmed);
    // abbreviate
    if (!name) {
        return undefined;
    }
    name = name.replace(' ounce', 'oz');
    name = name.replace(' pound', 'lb');
    return name;
};
exports.getShortUnitName = getShortUnitName;
var getPackagingType = function (variantName) {
    if (!variantName) {
        return undefined;
    }
    var shortUnitName = (0, exports.getShortUnitName)(variantName);
    var packagingTest = /^(jar|box|case|container|pack|package|tin)(?= of )/;
    var match = packagingTest.exec(shortUnitName);
    if (match) {
        return match[0];
    }
    packagingTest =
        /(?:^| )(baskets|bags|blocks|boxes|cases|containers|jars|mixes|packages|packs|pies|samples|tins|trays|bars)$/;
    match = packagingTest.exec(shortUnitName);
    if (match) {
        match = (0, singularize_1.default)(match[1]);
        return match.split(' ').pop();
    }
    packagingTest =
        /(?:^| )(basket|bag|block|box|case|container|jar|mix|package|pack|pie|sample|tin|tray|bar)$/;
    match = packagingTest.exec(shortUnitName);
    if (match) {
        return match[1];
    }
    return shortUnitName;
};
exports.getPackagingType = getPackagingType;
var pricePerPoundForQuantity = function (variant, quantity) {
    var _a = variant.prices, _b = _a === void 0 ? [] : _a, price = _b[0], salePrice = variant.salePrice, variationPrice = variant.variationPrice, weight = variant.weight;
    var pricePerPound;
    if (price && price.tiers) {
        // we can trust that this won't be an infinite loop because of `price.tiers`
        pricePerPound = (0, exports.priceForQuantity)(variant, quantity) / weight;
    }
    else {
        pricePerPound = salePrice / weight;
        pricePerPound *= 1 - (0, exports.discountDecimal)(variant, quantity);
    }
    if (variationPrice) {
        pricePerPound += variationPrice / weight;
    }
    return pricePerPound;
};
exports.pricePerPoundForQuantity = pricePerPoundForQuantity;
var priceForQuantity = function (variant, quantity) {
    if (quantity === void 0) { quantity = 1; }
    var _a = variant.prices, _b = _a === void 0 ? [] : _a, price = _b[0];
    if (price && price.tiers) {
        var value = [{ minimumQuantity: 1, value: price.value }]
            .concat(price.tiers)
            .filter(function (_a) {
            var minimumQuantity = _a.minimumQuantity;
            return minimumQuantity <= quantity;
        })
            .pop().value;
        return (0, money_1.dollars)(value);
    }
    var salePrice = variant.salePrice, variationPrice = variant.variationPrice;
    return (0, math_1.roundPrecision)((salePrice || 0) + (variationPrice || 0));
};
exports.priceForQuantity = priceForQuantity;
exports.default = {};
//# sourceMappingURL=sku.js.map